import {useState} from "react";
import classes from "./RightAside.module.css";
import CustomerModal from '../../../components/PosComponents/PosOrder/Modal/AddCustomer'
import { Link } from "react-router-dom";
const RightAside = () => {
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const openModal = () => setModalIsOpen(true);
	const closeModal = () => setModalIsOpen(false);
	return (
		<>
		<div
			id="kt_app_aside"
			className={`app-aside flex-column ${classes.rightAsideStyle}`}
			data-kt-drawer="true"
			data-kt-drawer-name="app-aside"
			data-kt-drawer-activate="{default: true, lg: false}"
			data-kt-drawer-overlay="true"
			data-kt-drawer-width="auto"
			data-kt-drawer-direction="end"
			data-kt-drawer-toggle="#kt_app_aside_mobile_toggle"
		>
			<div
				id="kt_app_aside_wrapper"
				className="d-flex flex-column align-items-center hover-scroll-y mt-lg-n3 py-5 py-lg-0 gap-4"
				data-kt-scroll="true"
				data-kt-scroll-activate="{default: false, lg: true}"
				data-kt-scroll-height="auto"
				data-kt-scroll-dependencies="#kt_app_header"
				data-kt-scroll-wrappers="#kt_app_aside_wrapper"
				data-kt-scroll-offset="5px"
			>
				{/* <a
					href="apps/calendar.html"
					className="btn btn-icon btn-color-primary bg-hover-body h-45px w-45px flex-shrink-0"
					data-bs-toggle="tooltip"
					title="Calendar"
					data-bs-custom-className="tooltip-inverse"
				>
					<i className="ki-outline ki-calendar fs-2x"></i>
				</a> */}
				<a
					className="btn btn-icon btn-color-warning bg-hover-body h-45px w-45px flex-shrink-0"
					data-bs-toggle="tooltip"
					title="Add New Customer"
					data-bs-custom-className="tooltip-inverse"
					onClick={openModal}
				>
					<i className="ki-outline ki-address-book fs-2x"></i>
				</a>
				<Link 
					to="/ordermanage/order/orderlist"
					className="btn btn-icon btn-color-success bg-hover-body h-45px w-45px flex-shrink-0"
					data-bs-toggle="tooltip"
					title="Order List"
					data-bs-custom-className="tooltip-inverse"
				>
					<i className="ki-outline ki-tablet-ok fs-2x"></i>
				</Link>
				{/* <a
					href="apps/inbox/listing.html"
					className="btn btn-icon btn-color-dark bg-hover-body h-45px w-45px flex-shrink-0"
					data-bs-toggle="tooltip"
					title="Products"
					data-bs-custom-className="tooltip-inverse"
				>
					<i className="ki-outline ki-calendar-add fs-2x"></i>
				</a> */}
			</div>
		</div>
		<CustomerModal modalIsOpen={modalIsOpen} closeModal={closeModal} />
		</>
	);
};

export default RightAside;
